import {HttpService} from "../http/HttpService";
import {CustomerInfo, OnramperLaunchResponse, PaymentDialog, PaymentMethod, PlayerOrder,RequestWithdrawResponse,WithdrawContext, VoucherRedemptionResult} from "../http/protocol";



export class PaymentsService {
    constructor(private http : HttpService) {}

    launcOnramp(currencyCode : string) : Promise<OnramperLaunchResponse>{
        return this.http.get("/onramper/launch/"+currencyCode);
    }

    getPaymentDialog(provider : string, order : PlayerOrder) : Promise<PaymentDialog> {
        return this.http.post("/payments/payment-dialog/"+provider ,order);
    }

    performDeposit(paymentId : string, customerInfo?: CustomerInfo) : Promise<any> {
        return this.http.post("/payments/deposit/perform/"+paymentId, customerInfo);
    }

    getPaymentMethods() : Promise<{[key:string]: PaymentMethod[]}>{
        return this.http.get("/payments/methods");
    }

    requestWithdraw(provider : string, order : PlayerOrder) : Promise<RequestWithdrawResponse> {
        return this.http.post("/payments/withdraw/"+provider, order);
    }

    getWithdrawContext(provider : string, method : string, currencyCode : string) : Promise<WithdrawContext> {
        return this.http.get("/payments/withdraw/context/" + provider + "/" + method + "/" + currencyCode);
    }

    getDepositContext(provider : string, method : string, currencyCode : string) : Promise<any> {
        return this.http.get("/payments/deposit/context/"+ provider + "/" + method + "/" + currencyCode);
    }

    redeemVoucher(code: string): Promise<VoucherRedemptionResult> {
        return this.http.post(`/payments/voucher/redeem/${code}`, null);
    }

}